import {
  Search,
  Target,
  GraduationCap,
  Users,
  BarChart3,
  RefreshCw,
} from "lucide-react";

const STEPS = [
  { icon: Search, title: "Analyse", text: "Wir analysieren Versorgungsgebiet, Potenziale und Zielgruppen." },
  { icon: Target, title: "Planung", text: "Wir entwickeln eine maßgeschneiderte Kampagnenstrategie und Einsatzplanung." },
  { icon: GraduationCap, title: "Ausbildung", text: "Unsere Teams werden fachlich, kommunikativ und ethisch vorbereitet." },
  { icon: Users, title: "Umsetzung", text: "Persönlicher Direktvertrieb vor Ort mit klarer Ansprache und Transparenz." },
  { icon: BarChart3, title: "Reporting", text: "Transparente Auswertung aller Ergebnisse und Kampagnenkennzahlen." },
  { icon: RefreshCw, title: "Optimierung", text: "Wir lernen, verbessern und steigern den Erfolg kontinuierlich." },
];

export default function Process() {
  return (
    <section
      id="versorger"
      data-testid="process-section"
      className="py-20 md:py-32 bg-[#F9FAFB]"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="text-center mb-16 md:mb-20">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0A3B2C] mb-4">
            Unser Vorgehen
          </div>
          <h2
            className="text-3xl md:text-5xl font-bold tracking-tight leading-[1.1] text-[#0A3B2C] max-w-3xl mx-auto"
            style={{ fontFamily: "Outfit, sans-serif" }}
            data-testid="process-title"
          >
            Strukturiert. Messbar. Erfolgreich.
          </h2>
        </div>

        {/* Steps grid with connecting line on lg */}
        <div className="relative">
          <div className="hidden lg:block absolute top-8 left-[8%] right-[8%] h-px bg-gradient-to-r from-transparent via-[#0A3B2C]/20 to-transparent" />

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <div
                  key={i}
                  data-testid={`process-step-${i + 1}`}
                  className="relative flex flex-col items-center text-center group"
                >
                  <div className="relative z-10 h-16 w-16 rounded-full bg-white border-2 border-[#0A3B2C] flex items-center justify-center font-bold text-[#0A3B2C] text-lg mb-4 shadow-sm group-hover:bg-[#0A3B2C] group-hover:text-white transition-all duration-300"
                    style={{ fontFamily: "Outfit, sans-serif" }}
                  >
                    {i + 1}
                  </div>
                  <div className="h-10 w-10 flex items-center justify-center text-[#0A3B2C] mb-3">
                    <Icon className="h-6 w-6" />
                  </div>
                  <h3
                    className="text-base md:text-lg font-semibold text-[#0A3B2C] mb-2"
                    style={{ fontFamily: "Outfit, sans-serif" }}
                  >
                    {s.title}
                  </h3>
                  <p className="text-xs md:text-sm text-gray-600 leading-relaxed">
                    {s.text}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
